import React from 'react';

function FloatMenuList(props) {
  const { moduleList } = props
  return (
    moduleList.map((data, index) => {
      return <li class="fab-buttons__item" key={index}>
        <a
          onClick={() => props.goToDiv(data)}
          className="fab-buttons__link black-color pb-2 px-1 cursor-hover"
        >
          {data === "cad" && "3D" || data !== 'qc' && data.charAt(0).toUpperCase() + data.slice(1) || 'Grading'}
        </a>
      </li>
    })
  )
}

export default FloatMenuList


// WEBPACK FOOTER //
// ./src/components/Costing/FloatMenuList/index.js